import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Menu({ active }) {
  const navigate = useNavigate();

  const go = (e, path) => {
    e.preventDefault();
    navigate(path);
  };

  return (
    <div className='Menu'>
        <nav className="navbar navbar-expand-lg bg-body-tertiary">
              <div className="container-fluid">
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M120-120v-560h160v-160h400v320h160v400H520v-160h-80v160H120Zm80-80h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm160 160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm160 320h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm160 480h80v-80h-80v80Zm0-160h80v-80h-80v80Z" /></svg>
                  <a
                    className="navbar-brand"
                    href="/"
                    onClick={(e) => go(e, '/')}
                  >
                    MEGAMONT
                  </a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
                    <div className="navbar-nav">
                        <a className={`nav-link ${active == 1 ? 'active' : ''}`} href="/" onClick={(e) => go(e, '/')}>Firma</a>
                        <a className={`nav-link ${active == 2 ? 'active' : ''}`} href="/offert" onClick={(e) => go(e, '/offert')}>Oferta</a>
                        <a className={`nav-link ${active == 3 ? 'active' : ''}`} href="/realizations" onClick={(e) => go(e, '/realizations')}>Realizacje</a>
                        <a className={`nav-link ${active == 4 ? 'active' : ''}`} href="/references" onClick={(e) => go(e, '/references')}>Referencje</a>
                        <a className={`nav-link ${active == 5 ? 'active' : ''}`} href="/contact" onClick={(e) => go(e, '/contact')}>Kontakt</a>
                    </div>
                </div>
            </div>
        </nav>
    </div>
  );
}